import {
  ConversationInfoMessageFragment,
  ConversationQuestionType,
  MeasurementRange,
  QualifiedFeature,
} from "fe-common/graphql";
import { PatientFacingQuestion } from "../../types/patientConversationAliasing";
import { Conversation } from "../../solverHooks/useConversation";
import { GenderValue } from "shared";

export enum ChoiceType {
  Suggestion,
  Yes_No,
  None,
  Dont_Know,
  Numeric,
}

export type ExchangeQuestionChoice = {
  text?: string;
  id: string;
  type: ChoiceType;
  featureId?: string;
  description?: string;
  range?: MeasurementRange;
};

export type ExchangeQuestion = {
  multipleSelection: boolean;
  progress: number;
  //Until we convert the component to work with non-specific-kahun type
  question?: PatientFacingQuestion;
};

export type ExchangeAnswer = {
  skip?: boolean;
  //Until we convert the component to work with non-specific-kahun type
  qfs?: QualifiedFeature[];
};

export type ExchangeInfo = ConversationInfoMessageFragment;

export type ConversationDriverExchange = {
  answer?: ExchangeAnswer;
  id: string;
  question: ExchangeQuestion;
  info?: ExchangeInfo[];
  type: ConversationQuestionType;
  error?: string;
  urgencyLevel?: string;
  hasMore?: boolean;
  gender?: GenderValue;
  previousAnswer?: ExchangeAnswer;
};

export type ConversationDriverExchangeResponse = {
  exchanges: ConversationDriverExchange[];
  debug?: DriverDebugData;
  gender: GenderValue;
};

export type ConversationInitialResponse = ConversationDriverExchangeResponse;

export type DriverDebugData = Conversation;

export enum ConversationStatus {
  CREATED = "CREATED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ABANDONED = "ABANDONED",
}

export type ExchangeResponse = {
  exchange: ConversationDriverExchange;
  debug: DriverDebugData;
  gender?: GenderValue;
};
